import { Component, OnInit,Input, ViewChild } from '@angular/core';
import { ReportMetadata ,Approver, ReportStates, Report} from '../models/report.model';
import { ReportdashboardService } from '../services/reportdashboard.service';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';
import { AuthUserService } from '../services/appInitialization/authUser.service';
import { LookupService } from '../services/lookups/lookup.service';
import { environment } from '../../environments/environment';
import {   ActivatedRoute} from '@angular/router';
import { User, HqLocationsModel, UserType } from '../models/user.model';
import { ReportlistingComponent } from './reportlisting/reportlisting.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { delay, finalize } from 'rxjs/operators';


@Component({
  selector: 'app-reportdashboard',
  templateUrl: './reportdashboard.component.html',
  styleUrls: ['./reportdashboard.component.css']
})
export class ReportdashboardComponent implements OnInit {

  displayMetadata =false;
  reportScheduleData:ReportMetadata[]=[];
  interimReportScheduleData:ReportMetadata[]=[];
  requiredReportScheduleData:ReportMetadata[]=[];
  voluntaryReportScheduleData:ReportMetadata[]=[];
  intrestReportScheduleData:ReportMetadata[]=[];
  reportMetadata: ReportMetadata;
  saveReportMetadatafields: any;
  saveStatus:boolean = false;
  selectedApprover :Approver;
  ApproverList : Approver[];
  type:string;
  accessLink :string;
  reportType:string;
  currentUser: User;
  @ViewChild(ReportlistingComponent) reportListing: ReportlistingComponent;
 // @Input() ApproverList : Approver[];
  constructor(private reportDashboardService:ReportdashboardService,
                private authUserService:AuthUserService,
                private lookupService:LookupService,
                private spinner: NgxSpinnerService
                //private reportService: ReportdashboardService,
               //private route:ActivatedRoute
              ) { }

  ngOnInit()
  {
     this.reportType="r";
     this.LoadReportSchedules();


  }

  LoadReportSchedules()
  {
    this.currentUser = this.authUserService._user;
    this.reportScheduleData = [];

    //this.spinner.show();
    this.reportDashboardService.getReportSchedule()
    .pipe(finalize(()=>this.spinner.hide()))
    .subscribe((data:ReportMetadata[])=>{
        this.reportScheduleData = data;
        this.reportScheduleData.sort((a,b):number=>{
          if (a.reportState > b.reportState) return 1;
          if (a.reportState < b.reportState) return -1;
          return 0;
        });

        let correctedReportSchedules = this.reportScheduleData.filter(x=>{
           if(x.reportStateId== ReportStates.RequestedForCorrection ||
            x.reportStateId== ReportStates.CorrectedAndSentToApprover||
            x.reportStateId== ReportStates.CorrectedAndSentToWashington)
            return x;
        });

        let otherStateReportSchedules = this.reportScheduleData.filter(x=>{
          if(x.reportStateId != ReportStates.RequestedForCorrection &&
           x.reportStateId != ReportStates.CorrectedAndSentToApprover&&
           x.reportStateId != ReportStates.CorrectedAndSentToWashington)
           return x;
       });

        this.reportScheduleData = correctedReportSchedules.concat(otherStateReportSchedules);
        this.requiredReportScheduleData =this.reportScheduleData.filter(rs => rs.isRequired == true);
       this.voluntaryReportScheduleData =this.reportScheduleData.filter(rs => rs.isRequired == false);


       if(this.currentUser.userType.typeName=='HQUser')
          {
            if(this.currentUser.userRoles[1].roleName !== 'Admin')
            {
              this.lookupService.getUserLocations().subscribe((userLocation: HqLocationsModel[]) => {

                this.requiredReportScheduleData = this.reportScheduleData.filter(rs => rs.programArea == userLocation[0].programArea && rs.isRequired == true);
                this.voluntaryReportScheduleData = this.reportScheduleData.filter(rs=>rs.isRequired == false);
                this.intrestReportScheduleData = this.reportScheduleData.filter(rs => rs.programArea != userLocation[0].programArea && rs.isRequired == true);

            });
          }
        }
     });
}

RefreshDataSource(isReload:boolean){
  // console.log(isReload);
  if(isReload)
    this.LoadReportSchedules();

}


  // onTabChange(val)
  // {
  //   if(val.index==0)
  //   {
  //     this.reportType ="r";
  //   }
  //   else
  //     this.reportType ="v";
  //   }
  //}


    //);

    //console.log(this.type);
    //  this.reportDashboardService.getReportSchedule().subscribe(
    //   (data:ReportMetadata[])=>{
    //     console.log(data);
    //     this.reportScheduleData =data;
    //   }
    // );
    // if(this.type=="r")
    // this.displayMetadata=false;
    // else
    // this.displayMetadata=true;

 // }

  // showMetadataDialog(id:any)
  // {
  //     this.saveStatus = false;
  //     this.reportDashboardService.getReportScheduleById(id).subscribe((metadata:ReportMetadata)=>{
  //     console.log(metadata);
  //     this.reportMetadata = metadata;
  //     this.reportMetadata.preparedBy =this.authUserService._user.firstName +" , " +this.authUserService._user.lastName ;
  //     //TODO: Remove the hard coded value for the report Type
  //     this.reportMetadata.reportType ="Required Report - Public Distribution";

  //     if(this.reportMetadata.approverId!==0)
  //     {
  //       this.saveStatus = true;
  //     }

  //     this.lookupService.getPostApprovers(this.reportMetadata.fasPostId).subscribe((approvers:[Approver]) =>{
  //     this.ApproverList = approvers;
  //     this.selectedApprover = approvers.find(approver => approver.id === this.reportMetadata.approverId)
  //    });

  //   });
  //   this.displayMetadata=true;
  // }
  //Moved to Report Listing Component
  // SaveReportMetadata() {
  //   this.saveReportMetadatafields = {id: this.reportMetadata.id,
  //                                    approverId: this.reportMetadata.approverId,
  //                                    highlights: this.reportMetadata.highlights,
  //                                    preferredReportName: this.reportMetadata.reportName

  //                                   };

  //   this.reportService.saveReportMetadata(this.saveReportMetadatafields).subscribe(
  //     (resp) => {
  //       if (resp.ok) {

  //         // SUCCESSFULLY ADDED
  //         alert("Saved Successfully");
  //         console.log(resp);
  //       }
  //     });

  // }
  // ViewReport()
  // {

  //     this.reportDashboardService.launchReport(this.reportMetadata.id).subscribe(
  //       (data) => {

  //           console.log(data);
  //           this.accessLink ="ms-word:ofe|u|"+ environment.serverUrl+"/"+ data;
  //           const link = document.createElement('a');
  //           link.href = this.accessLink;
  //           link.setAttribute('visibility', 'hidden');
  //           link.click();
  //           //TODO: The above code is not working for IE but works for Chorme
  //           //window.open(this.accessLink);


  //       }

  //     );
  //     console.log(this.accessLink);

  // }
  // onApproverChange(approver: Approver) {
  //   this.reportMetadata.approverId = approver.id;
  //   if (approver.id != null) {
  //     this.saveStatus = true;
  //   }
  // }
  // CancelReportMetadataDialog()
  // {
  //   this.displayMetadata=false;
  // }
}
